var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-reg-event__wrap"},[_c('div',{staticClass:"t-form__wrap2"},[_c('h2',{staticClass:"t-reg-event__title",domProps:{"innerHTML":_vm._s(_vm.props.formInfo.title)}}),_vm._v(" "),_c('div',{staticClass:"t-form__subtext",domProps:{"innerHTML":_vm._s(_vm.props.formInfo.description)}}),_vm._v(" "),_c('form-dynamic-cmp',{staticClass:"_width-big _reviews",attrs:{"form-info":_vm.props.formInfo,"button":_vm.props.button,"class-white":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/modals/collab.vue?vue&type=template&id=04009fca&
// module id = 1349
// module chunks = 0